// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "utf-8";

.app {
    margin: 12px 0px 12px 0px;
    max-width: 100%;
}

.line {
    font-size: 0px;
}

.line > .column {
    display: inline-block;
    vertical-align: middle;
    width: 33.33%;
}

.line > .column.left {
    text-align: left;
}

.line > .column.right {
    text-align: right;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/base.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":["@charset \"utf-8\";\r\n\r\n.app {\r\n    margin: 12px 0px 12px 0px;\r\n    max-width: 100%;\r\n}\r\n\r\n.line {\r\n    font-size: 0px;\r\n}\r\n\r\n.line > .column {\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n    width: 33.33%;\r\n}\r\n\r\n.line > .column.left {\r\n    text-align: left;\r\n}\r\n\r\n.line > .column.right {\r\n    text-align: right;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
